export default {
  // getCurrentUser(state) {
  //   return state.currentUser;
  // },

  getUserInView(state) {
    return state.userInView;
  },
};
